import { z } from 'zod';

export const TriggerProductGroupDoneEventSchema = z.object({
    productGroupId: z.string().uuid(),
});

export type TriggerProductGroupDonePayload = z.infer<typeof TriggerProductGroupDoneEventSchema>;
